import { ParentProps, Signal, createEffect } from "solid-js";
import { position } from "common";
import { DropdownContext, DropdownProvider, PopupRole } from "common";
import { DropdownTrigger } from "./fragments/DropdownTrigger";
import { DropdownContent } from "./fragments/DropdownContent";

export class DropdownMenuProps {
    open?: Signal<boolean>
    class?: string
    placement?: position.Placement
    target?: HTMLElement
    popup?: PopupRole
}

export default function Dropdown(props: ParentProps<DropdownMenuProps>) {
    const dropdownContext = new DropdownContext(props.open);
    dropdownContext.target = props.target;

    createEffect(() => dropdownContext.setPlacement(props.placement ?? 'bottom-start'));
    createEffect(() => dropdownContext.setPopup(props.popup ?? 'dialog'));

    return (
        <DropdownProvider value={dropdownContext}>
            {props.children}
        </DropdownProvider>
    )
}

Dropdown.defaultProps = new DropdownMenuProps();
Dropdown.Trigger = DropdownTrigger;
Dropdown.Content = DropdownContent;